import axios from 'axios';

// Use environment variable or fallback to backend URL
// The backend should be running on port 5000, not 3000
const baseURL = import.meta.env.VITE_APP_BASE_URL;

console.log('API Base URL:', baseURL);

const Api = axios.create({ 
  baseURL,
  timeout: 10000, // 10 second timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

const SECURE_API = axios.create({ 
  baseURL,
  timeout: 10000, // 10 second timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor for debugging
Api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

SECURE_API.interceptors.request.use(
  (config) => {
    const unParesdToken = localStorage.getItem("userData");
    
    if (unParesdToken) {
      // FIXED: Use atob for decoding Base64 JWT payload (not btoa)
      try {
        const tokenData = JSON.parse(atob(unParesdToken.split(".")[1]));
        
        const currentTime = Math.floor(Date.now() / 1000);
        if (tokenData.exp && tokenData.exp < currentTime) {
          localStorage.removeItem("userData");
          localStorage.removeItem("role");
          localStorage.clear();
          console.log("token has been expired");
          window.location.href = "/auth/Login";
        } else {
          config.headers.Authorization = `Bearer ${unParesdToken}`;
        }
      } catch (error) {
        console.error("Error parsing JWT token:", error);
        localStorage.removeItem("userData");
        localStorage.removeItem("role");
        localStorage.clear();
      }
    }
    
    console.log('SECURE_API Request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error("SECURE_API interceptor ~ Request error:", error);
    return Promise.reject(error);
  }
);

SECURE_API.interceptors.response.use(
  (response) => {
    console.log('SECURE_API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error("SECURE_API response interceptor ~ Response error:", error);
    if (error.code === 'ECONNREFUSED') {
      console.error("Backend server is not running. Please start the backend server on port 5000");
    }
    return Promise.reject(error);
  }
);

const ApiCall={
  SECURE_API,
  Api
}
export default ApiCall
